import axios from "axios";

import { useGlobalStore } from '../stores/global'
// [matrah] central error toasts
import { toastError, apiErrorMessage } from '../utils/notify'

const baseApiUrl = process.env.VUE_APP_BACK_END_BASE_API_URL;
const apiVersion = process.env.VUE_APP_BACK_END_BASE_API_VERSION;

const baseURL = `${baseApiUrl}/${apiVersion}/`;

let instance = axios.create({
    withCredentials: true,
    baseURL
});



instance.interceptors.request.use(async request => {
    // const globalStore = useGlobalStore();
    
    request.headers['Accept']       = 'application/json';
    request.headers['Content-Type'] = request.headers['Content-Type'] ? request.headers['Content-Type'] : 'application/json';
    request.headers['Authorization'] =  `Bearer ${  window.$cookies.get('jwt') ? window.$cookies.get('jwt') : null}`
    console.log({
        request,
        headers: request.headers['Content-Type']
    })
    console.log('loadding start');
    // store.dispatch("setIsLoading", true);
    // globalStore.enableLoading();
    return request;
});

instance.interceptors.response.use(
async response => { 
    // const globalStore = useGlobalStore();

    console.log('loadding end');
    // store.dispatch("setIsLoading", false);
    // globalStore.disableLoading();

    return response; 

},
error => {
    const globalStore = useGlobalStore();
    // store.dispatch("setIsLoading", false);
    globalStore.disableLoading();

        // [matrah] legacy: on 401 → remove cookie + window.location.reload() — reloading the login page
        // re-triggered the same unauthenticated calls, so the page flickered forever.
        // Now: clear the session and go to /login once; never reload when already there.
        if (error?.response?.status === 401) {
            window.$cookies.remove('jwt')
            const loginPath = `${(process.env.VUE_APP_BASE_URL || '/').replace(/\/+$/, '')}/login`
            if (!window.location.pathname.endsWith('/login') && !error?.config?.url?.includes('auth/login')) {
                window.location.replace(loginPath)
            }
        }

    // console.log('loadding end');

        // [matrah] central toast for UNEXPECTED failures (network down, 5xx, or any error a view
        // does not handle). Deferred by one macrotask: the calling view/store catches the error
        // first (microtasks) and, when it shows its own toast, marks it via toastApiError()/markHandled()
        // → no double toast. 401 is the session flow above; `config.silentError` opts a call out.
        const status = error?.response?.status
        if (!axios.isCancel(error) && status !== 401 && !error?.config?.silentError) {
            setTimeout(() => {
                if (!error.__toastHandled) toastError(apiErrorMessage(error, 'Request failed'))
            }, 0)
        }

        return Promise.reject(error);
    }
);

export default instance;
